export default __webpack_public_path__ + "static/media/Contact_Img@2x.e9f43ea7.png";